var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"full-wh",attrs:{"id":"main-view"}},[_c('Transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('img',{staticClass:"logo-menu",attrs:{"id":"logo_menu","src":require("@/assets/shapes/logo_menu.png")}}),_c('MenuPrincipal'),_c('LogoHome')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }